import routes from '@/Router/routes.constants'

export const isConfigPage = pathname => {
  return (
    pathname.startsWith(routes.configurationPage.index) || pathname.startsWith(routes.merchantConfigurationPage.index)
  )
}

export const reloadPage = () => {
  window.location.reload()
}

export const navigateTo = url => {
  window.location.assign(url)
}
